import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CCol,
  CImage,
  CRow,
  CAlert,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CFormText,
} from '@coreui/react'
import {
  cilPhone,
  cilXCircle,
  cilStar,
  cilArrowCircleLeft,
  //cilVerticalAlignCenter,
  cilSave,
  cilCopy,
  cilHandshake,
  cilChevronTop,
  cilChevronBottom,
  cilList,
  cilLoop1,
  cilLoop2,
  cilLoop3,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { Link, useNavigate } from 'react-router-dom'
import { isNull, set } from 'lodash'
import { buildApiUrl } from '../../utils/getConfiguration'

const SuppliersInnoIdeas = () => {
  const [visible, setVisible] = useState(false)
  const [visible1, setVisible1] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [ideaDescriptions, setIdeaDescriptions] = useState({}) // změna názvu a struktury stavu

  const fetchSuppliersData = async () => {
    try {
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(
        buildApiUrl('suppliers', {
          grp_ID,
        }),
      )
      setSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchSuppliersData()
  }, [])

  const [prefsuppliers, setPrefSuppliers] = useState([])

  const fetchPrefSuppliersData = async () => {
    try {
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      console.log('Preferred supplier is ', { reminder_ID, account_ID, grp_ID })
      const response = await apiClient.get(
        buildApiUrl('supplierPref', {
          reminder_ID,
          account_ID,
          grp_ID,
        }),
      )
      setPrefSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching supplier', error)
    }
  }

  useEffect(() => {
    if (
      String(localStorage.getItem('supplierid')) === 'null' &&
      String(localStorage.getItem('suppliertel')) === 'null'
    ) {
      console.log('Needed supplier')
      setVisible(true)
    } else {
      console.log('Not needed supplier')
      setVisible(false)
    }
    console.log(localStorage.getItem('suppliertel'))
    fetchPrefSuppliersData()
  }, [])

  const [startups, setStartups] = useState([])

  const fetchInnovationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(
        buildApiUrl('startupsList', {
          account_ID,
        }),
      )
      setStartups(response.data)

      // Inicializace hodnot pro každý startup
      const initialIdeas = {}
      response.data.forEach((startup) => {
        initialIdeas[startup.startup_id] = Array.isArray(startup.idea)
          ? startup.idea[0] || ''
          : startup.idea || ''
      })
      setIdeaDescriptions(initialIdeas)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchInnovationsData()
  }, [])

  let navigate = useNavigate()

  const handleClickUnassign = async (startup_ID) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('startupUnassign', {
          startup_ID,
          account_ID,
        }),
      )
      //localStorage.setItem('supplierid', 'null')
      //localStorage.setItem('suppliertel', 'null')
      fetchInnovationsData()
      setVisible(true)
      console.log('Unassigned startup ' + startup_ID)
      //localStorage.removeItem('supplierid')
      //window.history.back()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClickSave = async (startup_ID, type, idea) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //console.log('Supplier_ID ' + localStorage.getItem('supplierid'))

      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      //const supplier_ID = localStorage.getItem('supplierid')
      //const supplier_name = name
      //const supplier_contact_name = contact
      //const supplier_contact_tel = tel
      await apiClient.get(
        buildApiUrl('startupIdeaSave', {
          account_ID,
          startup_ID,
          type,
          idea,
        }),
      )
      // Example: buildApiUrl('startupAssign', { account_ID: 3, startup_ID: 1, idea: 'Test' })
      fetchInnovationsData()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  function mergeTel(str1) {
    return 'tel:' + str1
  }

  function getIdeaTypeLabel(type) {
    switch (type) {
      case 'F':
        return 'Favourite'
      case 'C':
        return 'Copy'
      case 'J':
        return 'Joint Cooperation'
      case isNull(type):
        return ''
    }
  }

  return (
    <>
      <CCard className="mb-4">
        <div style={{ color: 'white' }}>.</div>
        <div style={{ color: 'white' }}>.</div>
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Create innovation - Idea list</p>
            </h4>
          </CCol>
          <hr></hr>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                window.history.back()
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
            <CButton
              color="primary"
              className="float-end"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Selected startup list')
                navigate('/suppliersinnoproject')
                //window.history.back()
              }}
            >
              <CIcon icon={cilList} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard className="mb-4" color="light">
        <CCardBody>
          <h4 id="traffic" className="card-title mb-0">
            Ideas evaluation
          </h4>
          <hr />
          <CCol sm={12}>
            <CRow>
              {startups.length > 0 && (
                <div>
                  {startups.map((startup) => (
                    <div key={startup.startup_id}>
                      {/*{recommendation.reminder_ID === localStorage.getItem('taskid') && (*/}
                      <CCard key={startup.startup_id} className="mb-2">
                        <CCardBody>
                          <CRow className="g-2">
                            <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                              {/*<CCardImage orientation="top" src={avatar2} />*/}
                              <CImage
                                rounded
                                orientation="top"
                                src={'https://www.emerkur.eu/startups/' + startup.pic}
                                width={100}
                                height={30}
                              />
                            </CCol>
                            <hr />
                            <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                              <CCardText>
                                <b>Idea type:</b> {getIdeaTypeLabel(startup.type)}
                              </CCardText>
                            </CCol>
                            <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                              <CForm>
                                <CFormLabel htmlFor="ideaShortDescription">
                                  <b>Idea short description:</b> {startup.idea}
                                </CFormLabel>
                              </CForm>
                            </CCol>
                            <hr />
                            <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                              <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                Evaluation:
                              </CCol>
                              <CRow className="g-2">
                                <CCol xs={4} sm={3} md={3} lg={3} xl={2} xxl={2}>
                                  <CButton
                                    color="success"
                                    onClick={() => {
                                      console.log('Prio 3 for startup Nr.' + startup.startup_id)
                                      //handleClickSave(
                                      //  startup.startup_id,
                                      //  startup.type,
                                      //</CCol>  ideaDescriptions[startup.startup_id] || '',
                                      //)

                                      //localStorage.setItem('supplierid', 'null')
                                      //navigate('/supplierdetail')
                                    }}
                                  >
                                    <CIcon icon={cilStar} size="lg" />
                                  </CButton>
                                </CCol>
                                <CCol xs={4} sm={3} md={3} lg={3} xl={2} xxl={2}>
                                  <CButton
                                    color="success"
                                    onClick={() => {
                                      console.log('Prio 2 for startup Nr.' + startup.startup_id)
                                      //handleClickSave(
                                      //  startup.startup_id,
                                      //  startup.type,
                                      //</CCol>  ideaDescriptions[startup.startup_id] || '',
                                      //)

                                      //localStorage.setItem('supplierid', 'null')
                                      //navigate('/supplierdetail')
                                    }}
                                  >
                                    <CIcon icon={cilStar} size="lg" />
                                    <CIcon icon={cilStar} size="lg" />
                                  </CButton>
                                </CCol>
                                <CCol xs={4} sm={3} md={3} lg={3} xl={2} xxl={2}>
                                  <CButton
                                    color="success"
                                    onClick={() => {
                                      console.log('Prio 1 for startup Nr.' + startup.startup_id)
                                      //handleClickSave(
                                      //  startup.startup_id,
                                      //  startup.type,
                                      //</CCol>  ideaDescriptions[startup.startup_id] || '',
                                      //)

                                      //localStorage.setItem('supplierid', 'null')
                                      //navigate('/supplierdetail')
                                    }}
                                  >
                                    <CIcon icon={cilStar} size="lg" />
                                    <CIcon icon={cilStar} size="lg" />
                                    <CIcon icon={cilStar} size="lg" />
                                  </CButton>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>
                      {/*<CRow>
                        <WidgetsDropdown />
                      </CRow>*/}
                      {/*)}*/}
                    </div>
                  ))}
                </div>
              )}
            </CRow>
          </CCol>
          {/*
          <hr />
          <h4 id="traffic" className="card-title mb-0">
            Select Supplier
          </h4>
          {/*
          <CCol sm={12}>
            <div className="small text-medium-emphasis">
              {suppliers.length > 0 ? (
                <div>
                  {suppliers.map((supplier) => (
                    <div key={supplier.supplier_id}>
                      <div key={supplier.supplier_id}>
                        <div>
                          <CCard key={supplier.supplier_id} sm={2} className="mb-4">
                            <CCardBody>
                              <CRow>
                                <CCol>
                                  <CImage
                                    rounded
                                    orientation="top"
                                    src={supplier.supplierPic}
                                    width={50}
                                    height={50}
                                  />
                                  <CCardTitle>{supplier.supplierName}</CCardTitle>
                                  <CCardText className="p-1">
                                    {supplier.supplierContactName}
                                  </CCardText>
                                  <CCardText className="p-1">{supplier.supplierPhone}</CCardText>
                                </CCol>
                                <CCol>
                                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    Solve:
                                    <CButton
                                      color="primary"
                                      href={mergeTel(supplier.supplierPhone)}
                                      onClick={() => {
                                        console.log('Solve Task ' + supplier.supplier_id)
                                      }}
                                    >
                                      <CIcon icon={cilPhone} size="xxl" />
                                    </CButton>
                                    <CButton
                                      color="primary"
                                      onClick={() => {
                                        console.log('Task Detail ' + supplier.supplier_id)
                                        localStorage.setItem('supplierid', supplier.supplier_id)
                                        navigate('/supplierdetail')
                                      }}
                                    >
                                      <CIcon icon={cilList} size="xxl" />
                                    </CButton>
                                  </div>
                                  <hr />
                                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    Action:
                                    <CButton
                                      color="success"
                                      onClick={() => {
                                        console.log('Assign supplier ' + supplier.supplier_id)
                                        localStorage.setItem('supplierid', supplier.supplier_id)
                                        handleClickAssign(
                                          supplier.supplierName,
                                          supplier.supplierContactName,
                                          supplier.supplierPhone,
                                        )
                                      }}
                                    >
                                      <CIcon icon={cilVerticalAlignCenter} size="xxl" />
                                    </CButton>
                                  </div>
                                </CCol>
                              </CRow>
                            </CCardBody>
                          </CCard>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <CCardText className="alert alert-danger">
                    Suppliers data are now loaded...
                  </CCardText>
                </div>
              )}
            </div>
          </CCol>
          */}
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                console.log('Back')
                window.history.back()
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default SuppliersInnoIdeas
